import React from "react";
import * as headerStyles from "../header.module.css";
import * as navStyles from "../navbar.module.css";
import Item from "./Item";
import * as submenuStyles from "./submenuMega.module.css";

import ColumnContent from "./ColumnContent";
import useScrollbar from "./hooks/useScrollbar";
import useSubmenuUI from "./hooks/useSubmenuUI";
import LeftSwitcher from "./LeftSwitcher";
import MobileAccordion from "./MobileAccordion";

const SubmenuMega = ({menuItems = []}) => {
    const {
        activeItem,
        triangleTop,
        isMobile,
        expandedMobileItems,
        itemsRef,
        listRef,
        handleMouseEnter,
        toggleMobileItem,
    } = useSubmenuUI();

    const {
        hasOverflow,
        thumbTop,
        thumbHeight,
        isScrolling,
        isHoveringScrollbar,
        onScroll,
        handleScrollbarMouseEnter,
        handleScrollbarMouseLeave,
        handleThumbMouseDown,
    } = useScrollbar(listRef);

    // attach onScroll handler
    React.useLayoutEffect(() => {
        const container = listRef.current;
        if (container && onScroll) {
            container.addEventListener("scroll", onScroll);
        }
        return () => {
            if (container && onScroll) {
                container.removeEventListener("scroll", onScroll);
            }
        };
    }, [listRef, onScroll]);

    // Если нет данных — не рендерим UI
    if (!menuItems || menuItems.length === 0) {
        return null;
    }

    if (isMobile) {
        return (
            <div className={`${headerStyles.header__container} ${submenuStyles.submenuMega__container}`}>
                <div className={`${submenuStyles.submenuMega} ${isMobile ? submenuStyles.submenuMega__mobile : ""}`}>
                    <MobileAccordion
                        menuItems={menuItems}
                        expandedMobileItems={expandedMobileItems}
                        toggleMobileItem={toggleMobileItem}
                        Item={Item}
                        submenuStyles={submenuStyles}
                        navStyles={navStyles}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className={`${headerStyles.header__container} ${submenuStyles.submenuMega__container}`}>
            <div className={submenuStyles.submenuMega}>
                <LeftSwitcher
                    menuItems={menuItems}
                    activeItem={activeItem}
                    listRef={listRef}
                    itemsRef={itemsRef}
                    isScrolling={isScrolling}
                    hasOverflow={hasOverflow}
                    thumbTop={thumbTop}
                    thumbHeight={thumbHeight}
                    onThumbMouseDown={handleThumbMouseDown}
                    handleScrollbarMouseEnter={handleScrollbarMouseEnter}
                    handleScrollbarMouseLeave={handleScrollbarMouseLeave}
                    handleMouseEnter={handleMouseEnter}
                    Item={Item}
                    submenuStyles={submenuStyles}
                    navStyles={navStyles}
                    isHoveringScrollbar={isHoveringScrollbar}
                    triangleTop={triangleTop}
                />

                {menuItems[activeItem] && menuItems[activeItem].columns && (
                    <ColumnContent
                        columns={menuItems[activeItem].columns}
                        submenuStyles={submenuStyles}
                        navStyles={navStyles}
                        Item={Item}
                    />
                )}
            </div>
        </div>
    );
};

export default SubmenuMega;
